module.exports = __webpack_public_path__ + "img/PL08904.38cc871f.png";